define('bizzabo/models/Session',[
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'backbone',
    'backbone-validation',
    'bizzabo/models/SyncedModel',
    'bizzabo/models/ValidationObject'
], function(
    BZAPI,
    UTILS,
    Consts,
    Backbone,
    BackboneValidation,
    SyncedModel,
    ValidationObject
    ) {

    var Session = SyncedModel.extend({
        relationType: 'session',
        validationObject : undefined,
        isGhost : false, //todo ghost will not appear in the Day's relation
        defaults : {
            start : Consts.UI.agenda.DEFAULT_HOUR,
            duration : Consts.UI.agenda.DEFAULT_SESSION_DURATION,
            isColliding : false,
            invalidSpeaker : false
        },

        initialize : function() {
            if ((!this.has("end")) && this.has("start") && this.has("duration")) {
                this.set({
                    end : this.convertDurationToEnd(this.get("duration"))
                }, {
                    silent : true
                });
            }
            if (this.has("end") && this.get("duration") === Consts.UI.agenda.DEFAULT_SESSION_DURATION && this.has("start")) {
                this.set({
                    duration : this.convertEndToDuration(this.get("end"))
                }, {
                    silent : true
                });
            }
            this.validationObject = new ValidationObject(this);
            this.speakerErrors = {};
        },

        parse : function(response) {
            return this.unfoldMarkersData(response);
        },

        validation : {
            start : {
                fn : function(value) {
                    return this.validateStart(value);
                }
            },
            end : {
                fn : function(value) {
                    return this.validateEnd(value);
                }
            },
            duration : {
                fn : function(value) {
                    return this.validateDuration(value);
                }
            },
            name : [
                {
                    required : true,
                    msg : 'Title is required'
                },
                {
                    maxLength : 150,
                    msg : 'Title is too long'
                }
            ],
            description : {
                required : false,
                maxLength : 2500,
                msg : 'Description is too long'
            },
            location : {
                required : false,
                maxLength : 50,
                msg : 'Location is too long'
            },
            isColliding : {
                fn : function(value) {
                    return value ? "Overlaps another session" : undefined;
                }
            },
            invalidSpeaker : {
                fn : function(value) {
//                    return (value === true ? "Speaker is invalid" : undefined);
                    return (_.size(this.speakerErrors) > 0) ? "Speaker is invalid" : undefined;
                }
            }
        },

        validateEnd : function(value) {
            if (_.isUndefined(value)) {
                return; // not required
            }
            if (value == "") {
                return "End time is required"
            }
            var validateString = this.validateTimeString(value);
            if (validateString) {
                return validateString;
            }
            if (UTILS.timeStringToMinutes(value) < UTILS.timeStringToMinutes(this.get("start"))) {
                return "Flipped end and start";
            }
        },

        validateStart : function(value) {
            if (_.isUndefined(value) || value == "") {
                return "Start time is required"
            }
            var validateString = this.validateTimeString(value);
            if (validateString) {
                return validateString;
            }
        },

        validateDuration : function(value) {
            if (_.isUndefined(value)) {
                return "Duration is required"
            }
            if (value == "") {
                return "Duration is required"
            }
            if (value < Consts.UI.agenda.MIN_SESSION_DURATION) {
                return 'Min. duration is ' + Consts.UI.agenda.MIN_SESSION_DURATION + ' minutes';
            }
            if (value > 1440) {
                return 'Max. duration is 1440 minutes';
            }
        },

        validateTimeString : function(value) {
            var errorMsg = "Time format: hh:mm";
            if (_.isUndefined(value)) {
                return errorMsg;
            }
            if (value == "") {
                return "Start time is required";
            }
            var parts = ("" + value).split(":");
            if (parts.length == 2) {
                if (!(this.isLegalSingleTimeString(parts[0], 23) && this.isLegalSingleTimeString(parts[1], 59))) {
                    return errorMsg;
                }
            } else {
                return errorMsg;
            }
        },

        isLegalSingleTimeString : function(value, lim) {
            try {
                var intTime = parseInt(value);
            } catch (e) {
                return false;
            }
            if (_.isNaN(intTime)) {
                return false;
            }
            if (intTime > lim || intTime < 0) {
                return false;
            }
            return true;
        },

        setTime : function(map, triggerChangeEvent, doValidation) {
            var changed = "change";

            var newStart = map['start'];
            var newEnd = map['end'];
            var newDuration = map['duration'];

            var gotStart = !_.isUndefined(newStart);
            var gotEnd = !_.isUndefined(newEnd);
            var gotDuration = !_.isUndefined(newDuration);

            if (gotStart) {
                newStart = UTILS.ensure24hourFormat(newStart);
                if (this.get("start") != newStart) {
                    this.attributes.start = newStart;
                    changed += " change:start";
                }
            }
            if (gotDuration && this.get("duration") != newDuration) {
                this.attributes.duration = newDuration;
                changed += " change:duration";
            }
            if (gotEnd) {
                newEnd = UTILS.ensure24hourFormat(newEnd);
                if (this.get("end") != newEnd) {
                    this.attributes.end = newEnd;
                    changed += " change:end";
                }
            }

            if (gotStart || gotDuration) {
                if (_.isUndefined(this.validateStart(this.attributes.start)) && _.isUndefined(this.validateDuration(this.attributes.duration))) {
                    var calculatedEnd = this.convertDurationToEnd(newDuration, newStart);
                    if (this.get("end") != calculatedEnd) {
                        this.attributes.end = calculatedEnd;
                        changed += " change:end";
                    }
                }
            }
            if (gotEnd) {
                if (_.isUndefined(this.validateEnd(this.attributes.end)) && _.isUndefined(this.validateStart(this.attributes.start))) {
                    var calculatedDuration = this.convertEndToDuration(newEnd);
                    if (this.get("duration") != calculatedDuration) {
                        this.attributes.duration = calculatedDuration;
                        changed += " change:duration";
                    }
                }
            }

            if (triggerChangeEvent && changed != "change") {
                this.trigger(changed, this, {
                    fromForm : gotEnd
                });
            }
            if (doValidation && changed != "change") {
                this.validate();
            }
        },

        convertEndToDuration : function(end, start) {
            if (_.isUndefined(start)) {
                start = this.get("start");
            }
            var startInt = UTILS.timeStringToMinutes(start);
            var endInt = UTILS.timeStringToMinutes(end);
            return endInt - startInt;
        },

        convertDurationToEnd : function(duration, start) {
            if (_.isUndefined(start)) {
                start = this.get("start");
            }
            if (_.isUndefined(duration)) {
                duration = this.get("duration");
            }
            var startInt = UTILS.timeStringToMinutes(start);
            return UTILS.minutesToTimeString(startInt + parseInt(duration, 10));
        },

        unfoldMarkersData : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'markers-data');
        }

    });

    return Session;

});
